export const FLICK_TARGET_SWITCH = "FLICK_TARGET_SWITCH";
export const SET_IS_FLIGHT_FOCUS = "SET_IS_FLIGHT_FOCUS";
